import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=850bf346&scoped=true&"
import script from "./Tree.vue?vue&type=script&lang=js&"
export * from "./Tree.vue?vue&type=script&lang=js&"
import style0 from "./Tree.vue?vue&type=style&index=0&id=850bf346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850bf346",
  null
  
)

export default component.exports